import gql from "graphql-tag";

export const OPTIONS_PENDING_MODERATION_QUERY = gql`
  fragment ImageFragment on Image {
    id
    sourceUrl
    deletedAt
  }

  query OptionsPendingModeration($count: Int!) {
    options: optionsPendingModeration(count: $count) {
      id

      product {
        id
        sourceName
        sourceUrl

        images {
          ...ImageFragment
        }
      }

      image {
        ...ImageFragment
      }
    }
  }
`;

export {
  OptionsPendingModeration,
  OptionsPendingModerationVariables,
  OptionsPendingModeration_options as IOption,
  OptionsPendingModeration_options_image as IImage
} from "~/graphql/types";



// WEBPACK FOOTER //
// ./src/graphql/queries/optionModeration/optionsPendingImageModeration.ts